export const spacing = [0, 4, 8, 16, 32, 64];

export default spacing;
